// facets.js
"use strict";

/** Globale Referenzen */
let filterForm;
let productGridContainer;

/** DOM ready */
document.addEventListener("DOMContentLoaded", () => {
  // 1) Container & Form referenzieren
  productGridContainer = document.querySelector("#ProductGridContainer");
  filterForm = document.getElementById("FilterSortPanel");

  // 2) Delegierter Click-Listener für "Mehr laden"
  if (productGridContainer) {
    productGridContainer.addEventListener("click", (e) => {
      const btn = e.target.closest("#load-more");
      if (!btn) return;
      e.preventDefault();
      handleLoadMoreClick(btn);
    });
  }

  // 3) Swiper & Filter-Setup
  initSwipers();
  if (filterForm) setupFilterListeners();
});

/** Swiper-Initialisierung (Konfig wie bei dir) */
function initSwipers() {
  // Grid-Swiper
  try {
    const productGridConfig = {
      slidesPerView: 2,
      grid: { rows: 2, fill: "row" },
      spaceBetween: 0,
      allowTouchMove: false,
      breakpoints: { 1024: { slidesPerView: 4, grid: { rows: 1 } } },
    };
    if (window.Swiper) {
      new Swiper(".finkid-products-swiper .swiper-container", productGridConfig);
    }
  } catch (e) {
    console.warn("Swiper grid init skipped:", e);
  }

  // Produktbild-Swiper
  try {
    const productImageConfig = {
      loop: true,
      nested: true,
      fadeEffect: {},
      scrollbar: { el: ".swiper-scrollbar", hide: false, draggable: true },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    };
    if (window.Swiper) {
      document
        .querySelectorAll(".product-image-swiper")
        .forEach((el) => new Swiper(el, productImageConfig));
    }
  } catch (e) {
    console.warn("Swiper image init skipped:", e);
  }
}

/** Lädt per Fetch das nächste Fragment und hängt es ans Grid (Load More) */
function handleLoadMoreClick(btn) {
  const spinner = document.getElementById("load-more-spinner");

  // 1) Button ausblenden, Spinner zeigen
  btn.style.display = "none";
  if (spinner) spinner.classList.remove("hidden");

  // 2) Fetch starten
  fetch(btn.dataset.url)
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      // 2a) Neue Items ins Grid einfügen
      const grid = document.getElementById("product-grid");
      if (!grid) throw new Error("product-grid not found");
      doc.querySelectorAll("#product-grid li").forEach((li) => grid.appendChild(li));

      // 2b) Page-Counter erhöhen
      if (productGridContainer) {
        const cur = parseInt(productGridContainer.dataset.currentPage, 10) || 1;
        productGridContainer.dataset.currentPage = String(cur + 1);
      }

      // 2c) Load-More-Container aus dem Fragment ersetzen
      replaceLoadMoreContainerFrom(doc);

      // 3) Spinner wieder verstecken
      if (spinner) spinner.classList.add("hidden");

      // 4) Swiper & Farb-Zähler neu initialisieren
      initSwipers();
      reloadColorVariantCount(getFilterParams());
    })
    .catch((err) => {
      console.error("Fehler beim Nachladen:", err);
      // Im Fehlerfall: Spinner verstecken, Button wieder zeigen + Fehlertext
      if (spinner) spinner.classList.add("hidden");
      btn.style.display = "";
      btn.textContent = "Fehler – erneut laden";
    });
}

/** Ersetzt den #load-more-container im DOM durch den aus einem Response-Root (Document/Fragment/Element) */
function replaceLoadMoreContainerFrom(root) {
  const grid = document.getElementById("product-grid");
  if (!grid || !root) return;

  const oldContainer = document.getElementById("load-more-container");
  const newContainer = root.querySelector
    ? root.querySelector("#load-more-container")
    : null;

  if (newContainer) {
    if (oldContainer) {
      oldContainer.replaceWith(newContainer);
    } else {
      grid.insertAdjacentElement("afterend", newContainer);
    }
  } else if (oldContainer) {
    // Keine weitere Seite → Container entfernen
    oldContainer.remove();
  }
}

/** Serialisiert aktive Filter-Eingaben */
function getFilterParams() {
  const params = new URLSearchParams();
  const seen = new Set();

  if (!filterForm) return params.toString();

  filterForm
    .querySelectorAll('input[type="checkbox"], input[type="radio"], input[type="number"]')
    .forEach((input) => {
      // Nur checked Checkboxen/Radio + befüllte Number-Felder
      if ((input.type === "checkbox" || input.type === "radio") && !input.checked) return;
      if (!input.name || input.value === "") return;

      // Doppelte vermeiden (Desktop/Mobile gespiegelt)
      const key = `${input.name}|${input.value}`;
      if (seen.has(key)) return;
      seen.add(key);

      params.append(input.name, input.value);
    });

  return params.toString();
}

/** Farb-Variantenzähler (Section) nachladen */
function reloadColorVariantCount(paramsString) {
  const container = document.getElementById("ColorVariantCountContainer");
  if (!container) return;

  const url = `${window.location.pathname}?section_id=color-variant-count&${paramsString}`;
  fetch(url)
    .then((res) => res.text())
    .then((html) => {
      container.innerHTML = html;
    })
    .catch((err) =>
      console.error("Fehler beim Nachladen des Farbvariantenzählers:", err)
    );
}

/** Produkte mit aktuellen Filtern via AJAX holen (append = false → ersetzen, true → anhängen) */
function fetchFilteredProducts(append = false) {
  if (!productGridContainer) return;

  // 1) Aktuelle Seite auslesen
  const currentPage = parseInt(productGridContainer.dataset.currentPage, 10) || 1;
  const pageToLoad = append ? currentPage + 1 : 1;

  // 2) Filter-Parameter serialisieren
  const params = new URLSearchParams(getFilterParams());

  // Sortierung aus Hidden übernehmen (kanonischer Key: sort_by)
  const hidden = document.getElementById("sort_by_hidden");
  if (hidden && hidden.value) params.set("sort_by", hidden.value);

  // 3) AJAX-URL (dein Template rendert einen Ajax-View)
  const url =
    `${window.location.pathname}?view=ajax` +
    `&page=${pageToLoad}` +
    `&${params.toString()}`;

  // 4) Fetch + DOM-Update
  fetch(url)
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.text();
    })
    .then((html) => {
      const tmp = document.createElement("div");
      tmp.innerHTML = html;

      const grid = document.getElementById("product-grid");
      if (!grid) throw new Error("product-grid not found");

      const newItems = tmp.querySelectorAll("#product-grid li");
      if (!append) grid.innerHTML = "";
      newItems.forEach((li) => grid.appendChild(li));

      // 5) Page-Counter aktualisieren
      productGridContainer.dataset.currentPage = String(pageToLoad);

      // 6) Load-More-Container ersetzen/einfügen/entfernen (Element-Root → querySelector!)
      replaceLoadMoreContainerFrom(tmp);

      // 7) Swiper & Farb-Zähler neu initialisieren
      initSwipers();
      reloadColorVariantCount(getFilterParams());
    })
    .catch((err) => {
      console.error("Fehler beim Laden der Produkte:", err);
      const btn = document.getElementById("load-more");
      if (btn) {
        btn.disabled = false;
        btn.textContent = "Fehler – erneut laden";
      }
    });
}

/** Synchronisiert Desktop/Mobile-Filter-Eingaben */
function syncFilterInputs(changedInput) {
  const { type, name, value, checked } = changedInput;

  if (type === "checkbox") {
    document
      .querySelectorAll(`input[type="checkbox"][name="${name}"][value="${value}"]`)
      .forEach((cb) => {
        if (cb !== changedInput) cb.checked = checked;
      });
  } else if (type === "radio") {
    // Alle Radios mit gleichem Namen synchronisieren
    document
      .querySelectorAll(`input[type="radio"][name="${name}"]`)
      .forEach((radio) => {
        const isActive = radio.value === value;
        radio.checked = isActive;
        if (isActive) radio.setAttribute("checked", "");
        else radio.removeAttribute("checked");
      });
  } else if (type === "number") {
    document
      .querySelectorAll(`input[type="number"][name="${name}"]`)
      .forEach((input) => {
        if (input !== changedInput) input.value = value;
      });
  }
}

/** URL-Bar anhand aktueller Filter aktualisieren (kanonisch ohne UI-Only Keys) */
function updateURLFromFilters(sortVal) {
  const params = new URLSearchParams(getFilterParams());
  // UI-Only Keys entfernen
  params.delete("sort_by_mobile");
  params.delete("sort_by_desktop");
  if (sortVal) params.set("sort_by", sortVal);

  const newUrl = params.toString()
    ? `${window.location.pathname}?${params.toString()}`
    : window.location.pathname;

  window.history.replaceState({}, "", newUrl);
}

/** Listener für Filter/Sortierung */
function setupFilterListeners() {
  if (!filterForm) return;

  const desktopRadios = document.querySelectorAll('input[name="sort_by_desktop"]');
  const mobileRadios = document.querySelectorAll('input[name="sort_by_mobile"]');
  const hiddenInput = document.getElementById("sort_by_hidden");

  function onSortChange(event) {
    const val = event.target.value;

    // 1) UI-Sync
    desktopRadios.forEach((r) => (r.checked = r.value === val));
    mobileRadios.forEach((r) => (r.checked = r.value === val));

    // 2) Hidden setzen (kanonische Sortierung)
    if (hiddenInput) hiddenInput.value = val;

    // 3) URL-Bar updaten
    updateURLFromFilters(val);

    // 4) Grid neu laden (reset auf Seite 1)
    if (productGridContainer) productGridContainer.dataset.currentPage = "1";
    fetchFilteredProducts(false);
  }

  // Sort-Radios
  desktopRadios.forEach((r) => r.addEventListener("change", onSortChange));
  mobileRadios.forEach((r) => r.addEventListener("change", onSortChange));

  // Checkboxen & Number-Inputs (Filter)
  const otherInputs = filterForm.querySelectorAll(
    'input[type="checkbox"], input[type="number"]'
  );
  otherInputs.forEach((input) => {
    input.addEventListener("change", () => {
      // 1) Desktop/Mobile spiegeln
      syncFilterInputs(input);

      // 2) URL-Bar updaten (Sortierung aus Hidden – falls gesetzt)
      const sortVal = hiddenInput && hiddenInput.value ? hiddenInput.value : "";
      updateURLFromFilters(sortVal);

      // 3) Grid reset & neu laden
      if (productGridContainer) productGridContainer.dataset.currentPage = "1";
      fetchFilteredProducts(false);
    });
  });
}

/** Panel- & Filter-Utilities (werden von deinem Template aufgerufen) */
function toggle_filter_sort_panel(event) {
  const panel = document.getElementById("FilterSortPanel");
  if (!panel) return;
  const isMobile = window.innerWidth < 750;

  if (!event) {
    panel.classList.toggle("open");
    document.body.classList.toggle(
      "overflow-hidden",
      panel.classList.contains("open") && isMobile
    );
    return;
  }

  if (event.target === event.currentTarget) {
    panel.classList.remove("open");
    if (isMobile) document.body.classList.remove("overflow-hidden");
  }
}

function resetAllFilters() {
  if (!filterForm || !productGridContainer) return;

  // Alle Checkboxen/Radio/Numbers zurücksetzen
  filterForm
    .querySelectorAll('input[type="checkbox"], input[type="radio"]')
    .forEach((i) => (i.checked = false));
  filterForm.querySelectorAll('input[type="number"]').forEach((i) => (i.value = ""));

  // komplette Seite neu laden (sauberster Reset inkl. Button/Spinner/State)
  window.location.href = window.location.pathname;
}

function toggleMobileFilterDrawer() {
  const drawer = document.getElementById("MobileFilterDrawer");
  if (drawer) drawer.classList.toggle("open");
}
